<template>
  <div>
    <div style="display: flex;justify-content: center">
      <input type="password" v-for="i in maxlength" :key="i - 1" ref="inputs" :value="value[i - 1]"
             @keydown.prevent="handleKeyDown" maxlength="1"/>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {type: String, required: true},
      maxlength: {type: Number, default: 6}
    },
      mounted(){
      this.$refs.inputs[0].focus()
      },
    methods: {
      handleKeyDown(event) {
        let str = this.value;
        if (event.key >= "0" && event.key <= "9") {
          if (this.value.length < this.maxlength) str += event.key;
        } else if (event.key === "Backspace") {
          str = this.value.substring(0, this.value.length - 1);
        }

        this.$refs.inputs[Math.min(str.length, this.maxlength - 1)].focus();
        this.$emit('input', str);
      }
    }
  }
</script>

<style scoped>
  input {
    width: 50px;
    height: 40px;
    margin: 0;
    padding-left: 20px;
    border: 1px solid #cccccc;
    border-right-width:0 ;
  }
  input:last-child{
    border-right:1px solid #cccccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/passwordInput.vue